import { render, staticRenderFns } from "./addgroup.vue?vue&type=template&id=23894bde&"
import script from "./addgroup.vue?vue&type=script&lang=js&"
export * from "./addgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports